<template>
  <div class="container" style="margin-top: 120px">
    <b-row>
      <div v-if="product"  class="col-lg-6">
          <h5>Product Information</h5>
          <table class="table mt-5">
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-right">Price(Rs.)</th>
                <th class="text-right">Tax</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td class="text-left">{{product.name}}</td>
                <td class="text-right">{{product.price}}</td>
                <td class="text-right">{{product.tax}}</td>
              </tr>
            </tbody>
          </table>
          <h5>Product description</h5>
          <ul v-for="(desc, index) in product.description" :key="index">
            <li>{{desc}}</li>
          </ul>
      </div>
      <div class="col-lg-6">
        <b-card>
          <h5 style="border-bottom: 1px #d3d3d3 solid" class="pb-3">Cart total(Rs.)</h5>
          <div class="d-flex justify-content-between">
            <p>Order total</p>
            <p>{{order_total}}</p>
          </div>
          <Checkout :package_id="product.package_id"/>
        </b-card>
      </div>
    </b-row>
  </div>
</template>

<script>
const Checkout = () => import(/* webpackPrefetch: true */ "@/components/Checkout");

export default {
  name:"payment",
  beforeMount() {
    this.product = this.$route.params.product;
    console.log(this.product);
    this.type = this.$route.params.type;
    this.order_total = this.product.price + this.product.tax;
    // if(this.product)
    // this.getTotal(this.products);
    // console.log(this.products);
  },
  components: {
    Checkout
  },
  data() {
    return {
      products: [],
      order_total: 0,
      type: ''
    };
  },

}
</script>
